module.exports = "/images/ar.svg?59d6cdc1f2a94bbaf11d223f0b9f3153";